"use strict";
module.exports = (function() {return ["apipasswordInputDef.js","emailInputDef.js","filenameInputDef.js","passwordInputDef.js","usernameInputDef.js"];})();